import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #ececec;
  border-radius: 8px;
  margin-bottom: 25px;
`;

export const ItemTable = styled.div`
  border-radius: 3px;
  margin: 10px 0;
  display: flex;
  justify-content: space-between;

  .col-1 {
    margin-left: 24px;
    flex: 4;
    text-align: left;
  }
  .col-2 {
    flex: 2;
    text-align: left;
  }
  .col-3 {
    flex: 1.5;
    text-align: left;
  }
  .col-4 {
    flex: 1.5;
    text-align: left;
  }
  .col-5 {
    flex: 0.5;
    text-align: left;
  }
`;

export const FlexContainer = styled.div`
  align-items: center;
  display: flex;
  .idProposta {
    color: #2d5bff;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }
`;

export const FlexContainerText = styled.div``;

export const PhotoImg = styled.img`
  min-width: 56px !important;
  max-width: 56px !important;
  min-height: 56px !important;
  max-height: 56px !important;
  border-radius: 50%;
  transform: matrix(-1, 0, 0, 1, 0, 0);
  object-fit: cover;
  object-position: center;
`;

export const TitleText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  min-width: 200px;

  letter-spacing: -0.01em;

  color: #333333;
`;

export const TextFicha = styled.p`
  //styleName: MD / Regular;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: #333333;
`;

export const TextCotacao = styled.p`
  //styleName: MD / Regular;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
`;

export const TextEtapa = styled.div`
  //styleName: LG/Semibold;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #333333;
`;

export const ArrowButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #333333;
`;

export const SubTitleText = styled.p`
  font-family: "Inter";
  font-weight: 400;
  font-size: 16px;
  min-width: 200px;

  color: #333333;
`;
